export const OrderLineItemConstants = {
    DESCRIPTION_MAX_LENGTH: 120,
    INITIAL_QUANTITY_VALUE: '1',
} as const;
